import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useGrid } from '@crm-framework/grid';
import { Checkbox } from '@crm-framework/checkbox';

import { getNotificationData } from '../../selectors';
import { NOTIFICATIONS_GRID_NAME } from '../../consts';
import { notificationsActions } from '../../NotificationsStore';

export const GridGeneralSelectCheckbox: React.FC = () => {
  const dispatch = useDispatch();

  const { selectedIds } = useSelector(getNotificationData);
  const { items } = useGrid(NOTIFICATIONS_GRID_NAME);

  const onChange = useCallback(
    (isChecked: boolean) => {
      if (isChecked) {
        const ids = items.map((item) => item.notificationDetails.id);
        dispatch(notificationsActions.setSelectedIds({ ids }));
      } else {
        dispatch(notificationsActions.setSelectedIds({ ids: [] }));
      }
    },
    [dispatch, items]
  );

  return (
    <Checkbox
      checked={selectedIds.length !== 0 && selectedIds.length === items.length}
      onChange={onChange}
    />
  );
};
